import { render, staticRenderFns } from "./ECommerceWishlist.vue?vue&type=template&id=3aec6b74"
import script from "./ECommerceWishlist.vue?vue&type=script&lang=js"
export * from "./ECommerceWishlist.vue?vue&type=script&lang=js"
import style0 from "./ECommerceWishlist.vue?vue&type=style&index=0&id=3aec6b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports